// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.globalFooter {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 52px;
  background-color: transparent;
  padding: 10px 40px 10px 112px;
  text-align: center;
  font-size: 12px;
}
.globalFooter .iconSmall {
  display: none;
}
.globalFooter .imageWrapper {
  float: left;
  margin: 0 15px 0 0;
}
.globalFooter .imageWrapper img {
  max-height: 48px;
  max-width: 100px;
  width: auto;
}
.globalFooter .vettingLabel {
  height: 68px;
}
.globalFooter > p,
.globalFooter > section {
  display: inline;
  margin-top: 12px;
}
.globalFooter > p {
  color: #262626;
  opacity: 0.5;
}
.globalFooter > section {
  color: #19419b;
}
.globalFooter > section .globalFooterText {
  opacity: 0.6;
}
@media (max-width: 599px) {
  .globalFooter {
    padding: 0;
    height: 46px;
  }
  .globalFooter .iconMedium {
    display: none;
  }
  .globalFooter .iconSmall {
    display: block;
  }
  .globalFooter .imageWrapper img {
    max-width: 80px;
    max-height: 31px;
    width: auto;
  }
  .globalFooter p,
  .globalFooter section {
    margin: auto;
    line-height: 21px;
    display: block;
  }
  .globalFooter .vettingLabel {
    height: 30px;
  }
}
.PoweredBy {
  height: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/layouts/footer/Footer.less"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EAEA,6BAAA;EACA,kBAAA;EACA,eAAA;AAFD;AAPA;EAYE,aAAA;AAFF;AAVA;EAgBE,WAAA;EACA,kBAAA;AAHF;AAdA;EAoBG,gBAAA;EACA,gBAAA;EACA,WAAA;AAHH;AAnBA;EA2BE,YAAA;AALF;AAtBA;;EAgCE,eAAA;EACA,gBAAA;AANF;AA3BA;EAoCE,cAAA;EACA,YAAA;AANF;AA/BA;EAwCE,cAAA;AANF;AAlCA;EA0CG,YAAA;AALH;AAUA;EAIC;IACC,UAAA;IACA,YAAA;EAXA;EASD;IAKE,aAAA;EAXD;EAMD;IASE,cAAA;EAZD;EAGD;IAaE,eAAA;IACA,gBAAA;IACA,WAAA;EAbD;EAFD;;IAoBE,YAAA;IACA,iBAAA;IACA,cAAA;EAdD;EARD;IAyBE,YAAA;EAdD;AACF;AAkBA;EACC,aAAA;AAhBD","sourcesContent":["@import (reference) '../../constants.less';\n\n.globalFooter {\n\tposition: absolute;\n\tbottom: 0;\n\twidth: 100%;\n\theight: @globalFooterHeight;\n\tbackground-color: transparent;\n\t// TODO: Update the padding right equal to the nav bar\n\tpadding: 10px @layoutPadding 10px (@navBarWidth + 32px);\n\ttext-align: center;\n\tfont-size: 12px;\n\n\t.iconSmall {\n\t\tdisplay: none;\n\t}\n\n\t.imageWrapper {\n\t\tfloat: left;\n\t\tmargin: @footerImageWrapperMargin;\n\n\t\timg {\n\t\t\tmax-height: 48px;\n\t\t\tmax-width: 100px;\n\t\t\twidth: auto;\n\t\t}\n\t}\n\n\t.vettingLabel {\n\t\theight: 68px;\n\t}\n\t\n\t> p,\n\t> section {\n\t\tdisplay: inline;\n\t\tmargin-top: 12px;\n\t}\n\t> p {\n\t\tcolor: @backgroundColor;\n\t\topacity: 0.5;\n\t}\n\t> section {\n\t\tcolor: @brightNavy;\n\t\t.globalFooterText {\n\t\t\topacity: 0.6;\n\t\t}\n\t}\n}\n\n@media (max-width: @phoneOnlyMaxWidth) {\n\t@paddingBottom: 20px;\n\t@iconHeight: 31px;\n\n\t.globalFooter {\n\t\tpadding: 0;\n\t\theight: @globalFooterHeightForMobile;\n\n\t\t.iconMedium {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t.iconSmall {\n\t\t\tdisplay: block;\n\t\t}\n\n\t\t.imageWrapper img {\n\t\t\tmax-width: 80px;\n\t\t\tmax-height: @iconHeight;\n\t\t\twidth: auto;\n\t\t}\n\n\t\tp,\n\t\tsection {\n\t\t\tmargin: auto;\n\t\t\tline-height: 21px;\n\t\t\tdisplay: block;\n\t\t}\n\t\t.vettingLabel {\n\t\t\theight: 30px;\n\t\t}\n\t}\n}\n\n.PoweredBy {\n\theight: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
